import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLocalizedPath } from '../hooks/useLocalizedPath';
import { useI18nLocaleSync } from '../hooks/useI18nLocaleSync';
import { useAppLocale } from '../hooks/useAppLocale';
import { pathWithLocale } from '../lib/locale';
import { AboutBodyEn, AboutBodyKo } from './content/AboutBodies';

export function About() {
  const { t } = useTranslation();
  const locale = useAppLocale();
  const lp = useLocalizedPath();

  useI18nLocaleSync();

  usePageMeta({
    title: locale === 'ko' ? '소개 – 무료 로또 번호 생성기' : t('about.metaTitle'),
    description: locale === 'ko' ? '무료 로또 번호 생성기의 원리와 기능을 알아보세요.' : t('about.metaDesc'),
    path: pathWithLocale('/about', locale),
    noindex: locale !== 'en' && locale !== 'ko',
  });

  return (
    <main className="content">
      <nav className="breadcrumb" aria-label={t('layout.breadcrumbLabel')}>
        <Link to={lp('/')}>{t('breadcrumb.home')}</Link>
        <span className="sep">/</span>
        <span className="current">{t('nav.about')}</span>
      </nav>

      {locale === 'ko' ? <AboutBodyKo lp={lp} /> : <AboutBodyEn lp={lp} />}
    </main>
  );
}
